<template>
	<VideoTile
		:item="video"
		:title="video.title"
		:sport-name="sportName"
		:description="video.uploadedDate"
		@share="handleShare"
		@click="handlePlay"
	/>
</template>

<script>
import VideoTile from './VideoTile';

export default {
	name:       'VideoRow',
	components: { VideoTile },
	props:      {
		video: {
			type:    Object,
			default: null,
		},
		sportName: {
			type:    String,
			default: '',
		},
		event: {
			type:     Object,
			required: true,
		},
	},
	data() {
		return {
			imageLoadingError: false,
		};
	},
	computed: {
		videoId() {
			return this.video.id;
		},
		title() {
			if (!this.video) {
				return null;
			}
			return this.transTagLabel(this.video.name, this.sportName);
		},
		teamName() {
			if (!this.video || !this.video.team) {
				return null;
			}
			return this.video.team;
		},
		playerName() {
			if (!this.video || !this.video.player) {
				return null;
			}
			return this.video.player.name;
		},
		imageUrl() {
			if (!this.video) {
				return null;
			}
			if (!this.video.imageUrl) {
				return '/images/background-player.jpg';
			}
			return this.video.imageUrl;
		},
	},
	methods: {
		handlePlay() {
			this.$emit('play', this.video);
		},
		handleEdit() {
			this.$emit('edit', this.video);
		},
		handleMouseEnter() {
			this.$emit('item-hover', this.video);
		},
		handleMouseLeave() {
			this.$emit('item-unhover', this.video);
		},
		handleShare() {
			this.$emit('share', this.video);
		},
		handleDelete() {
			this.$emit('delete', this.video);
		},
	},
};
</script>

<style lang="scss">
</style>
